import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";
import { MoveableSubAccountStoreStatic } from "./MoveableSubAccountStoreStatic";
import { InvestmentTransferStoreStatic } from "./InvestmentTransferStoreStatic";
import { TransferRequestStoreStatic } from "./TransferRequestStoreStatic";
import { DestinationSubAccountStoreStatic } from "./DestinationSubAccountStoreStatic";
import { SingleDataStoreDispacher } from "../../../Shared/Stores/SingleDataStoreDispacher";
import { TransferDestinationAccountModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { SingleDataStore } from "../../../Shared/Stores/SingleDataStore";
import { TransferDestinationAccountsClient } from "../../../../Wrap/Api/Transfer/TransferAccounts/TransferDestinationAccounts";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const MoveableSubAccountDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const MoveableSubAccountStore: MoveableSubAccountStoreStatic = new MoveableSubAccountStoreStatic();
export const InvestmentTransferDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const InvestmentTransferStore: InvestmentTransferStoreStatic = new InvestmentTransferStoreStatic();
export const TransferRequestDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const TransferRequestStore: TransferRequestStoreStatic = new TransferRequestStoreStatic();
export const DestinationSubAccountDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const DestinationSubAccountStore: DestinationSubAccountStoreStatic = new DestinationSubAccountStoreStatic();
export const DestinationSubAccountFromRequestDispatcher: SingleDataStoreDispacher<TransferDestinationAccountModel> = new SingleDataStoreDispacher<TransferDestinationAccountModel>();
export const DestinationSubAccountFromRequestStore: SingleDataStore<TransferDestinationAccountModel> = new SingleDataStore<TransferDestinationAccountModel>(DestinationSubAccountFromRequestDispatcher);

